module.exports = __webpack_public_path__ + "img/l5.ffa1531a.jpg";